import { render, staticRenderFns } from "./TabAddresses.vue?vue&type=template&id=4219b2fa&"
import script from "./TabAddresses.vue?vue&type=script&lang=js&"
export * from "./TabAddresses.vue?vue&type=script&lang=js&"
import style0 from "./TabAddresses.vue?vue&type=style&index=0&id=4219b2fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports